function clearCart_func(event) {
  console.log("this is from clearCart_func first...");
  // Prevent the default form submission
  event.preventDefault();
  sessionStorage.removeItem('popupLastClosed');
   console.log("this is from clearCart_func second...");
  // Clear the cart using Shopify's Ajax API
  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => response.json())
  .then(data => {
    console.log('Cart cleared:', data);
    // Once the cart is cleared, log the user out
    window.location.href = '/account/logout';
  })
  .catch(error => {
    console.error('Error clearing the cart:', error);
    // If there's an error, still proceed with logout
    window.location.href = '/account/logout';
  });
}
